export const CHANNEL_BASE_OPTIONS = [
  { id: "outbound", name: "Outbound" },
];

export const ATS_EMPLOYEE_STATUS_OPTIONS = [
  { id: "current", name: "Current" },
  { id: "former", name: "Former" },
];

export const JOB_POSTING_STATUS_OPTIONS = [
  { id: "posted", name: "Posted" },
  { id: "filled", name: "Filled" },
  { id: "unposted", name: "Unposted" },
];

export const ATS_EMPLOYEE_REHIRE_STATUS_OPTIONS = [
  { id: "current", name: "Current" },
  { id: "rehire_eligible", name: "Rehire Eligible" },
  { id: "rehire_ineligible", name: "Rehire Ineligible" },
];

export const ORIGIN_BASE_OPTIONS = [
  { id: "extension", name: "Extension" },
  { id: "stream", name: "Stream" },
  { id: "csv", name: "CSV upload" },
  { id: "recommendations", name: "Humanly recommended" },
];

export const AVG_RECENT_TENURE_OPTIONS = [
  { name: "very-short", id: "very-short-0-1" },
  { name: "short", id: "short-1-3" },
  { name: "medium", id: "medium-3-6" },
  { name: "long", id: "long-6-10" },
  { name: "very-long", id: "very-long-10-inf" },
];

// keep list consistent with topfunnel-web/app/services/crunchbase/metrics_service.rb
// Used for emp_start_size, emp_end_size, emp_current_start_size (profile.employments.metrics)
export const EMP_SIZE_OPTIONS = [
  { label: "1-10", value: "1-10" },
  { label: "11-50", value: "11-50" },
  { label: "51-200", value: "51-200" },
  { label: "201-500", value: "201-500" },
  { label: "501-1,000", value: "501-1,000" },
  { label: "1,001-5,000", value: "1,001-5,000" },
  { label: "5,001-10,000", value: "5,001-10,000" },
  { label: "10,000+", value: "10,000+" },
];


export const EMP_GROWTH_RATE_OPTIONS = [
  { label: "Negative", value: "negative-inf-0" },
  { label: "Static (0)", value: "static-0" },
  { label: "Slow (0-10)", value: "small-0-10" },
  { label: "Medium (10-25)", value: "medium-10-25" },
  { label: "Fast (25-99)", value: "large-25-99" },
  { label: "Very fast (100+)", value: "very-large-100-inf" },
];

// keep list consistent with topfunnel-web/app/services/crunchbase/metrics_service.rb
export const EARLY_AT_COMPANY_OPTIONS = [
  { name: "very-early", id: "very-early-0-1" },
  { name: "early", id: "early-1-3" },
  { name: "middle", id: "mid-3-6" },
  { name: "late", id: "late-6-10" },
  { name: "very-late", id: "very-late-10-inf" },
];

export const CANDIDATE_STATUS_OPTIONS = [
  {
    value: "sourced",
    label: "Sourced",
  },
  {
    value: "reached",
    label: "Reached",
  },
  {
    value: "responded",
    label: "Responded",
  },
  {
    value: "interested",
    label: "Interested",
  },
  {
    value: "interview",
    label: "Interviewed",
  },
  {
    value: "hired",
    label: "Hired",
  },
];

